import gql from 'graphql-tag';

export default gql`
  query getCustomerLoyaltyRewards($memberId: String ) {
    getCustomerLoyaltyRewards(memberId: $memberId) {
      rewards {
        rewardId
        expirationDate
        amount
      }
      rewardsTotal
    }
  }
`;

